import Swal from 'sweetalert2';

/** Elige módulo activo. */
export function pickModule(data: { module?: unknown; modules?: unknown[] }): unknown {
  if (data.module) return data.module;
  return data.modules?.[0] ?? null;
}

/** Elige primer grupo. */
export function pickGroup(data: { groups?: unknown[] }): unknown {
  return data.groups?.[0] ?? null;
}

/** Elige id de primera categoría. */
export function pickCategoryId(data: { categories?: Array<{ id: string }> }): string | null {
  return data.categories?.[0]?.id ?? null;
}

/** Indica si hay contexto para cargar categorías. */
export function canLoadCategories(module: unknown, group: unknown): boolean {
  return Boolean(module) && Boolean(group);
}

/** Toma id de la primera categoría. */
export function firstCategoryId(categories: Array<{ id: string }>): string | null {
  if (categories.length === 0) return null;
  return categories[0].id;
}

/** Inserta o reemplaza categoría en lista. */
export function upsertCategoryRow(list: unknown[], formValue: { id?: unknown }): void {
  if (formValue.id) replaceCategoryRow(list, formValue);
  else list.push(formValue);
}

/** Reemplaza fila existente por id. */
export function replaceCategoryRow(list: unknown[], formValue: { id?: unknown }): void {
  const idx = findCategoryIndex(list, formValue);
  list[idx] = formValue;
}

/** Busca índice de categoría por id. */
export function findCategoryIndex(list: unknown[], formValue: { id?: unknown }): number {
  return list.findIndex((x) => categoryMatches(x, formValue));
}

/** Compara id de categoría. */
export function categoryMatches(row: unknown, formValue: { id?: unknown }): boolean {
  return (row as { id?: unknown }).id === formValue.id;
}

/** Pide confirmación de borrado de categoría. */
export function confirmRemoveCategory(onConfirm: () => void): void {
  Swal.fire({
    title: '¿Seguro?',
    text: 'Se eliminarán todas las preguntas asociadas',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  }).then((result) => handleRemoveResult(result, onConfirm));
}

/** Ejecuta borrado si fue confirmado. */
export function handleRemoveResult(result: { isConfirmed: boolean }, onConfirm: () => void): void {
  if (result.isConfirmed === true) onConfirm();
}
